import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import { faSignOut } from '@fortawesome/free-solid-svg-icons';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { faListUl } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-admin-layout',
    templateUrl: './admin-layout.component.html',
    styleUrls: ['./admin-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminLayoutComponent {
  constructor(private auth: AuthService) {}
  onRouterLinkActive: any;
  faHome = faHome;
  faFile = faFile;
  faGear = faGear;
  faSignOut = faSignOut;
  faUsers = faUsers;
  faListUl = faListUl;

  logout(): void {
    this.auth.logout();
  }
}
